import Vue from 'vue'
import App from './App.vue'
import router from './router'
import constant from './plugins/constant'
import Vuelidate from 'vuelidate'
import store from './store'
import Vuex from 'vuex'
import VueGtm from 'vue-gtm-custom'
import VueMeta from 'vue-meta'
import VueCookies from 'vue-cookies'

const theme = navigator.userAgent.split(/sdk\/(\d+.\d+.\d+) \(.*\) /).pop()
if (theme) {
  document.documentElement.setAttribute('data-theme', theme.trim().toLowerCase())
}

Vue.use(constant)
Vue.use(Vuex)
Vue.use(Vuelidate)
Vue.use(VueMeta)
Vue.use(VueCookies)

Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM_SERVER_ID,
  defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  baseUrl: process.env.VUE_APP_GTM_SERVER_URL // defaults to ''. Allows the base url modification from googletagmanager.com to a custom domain. Necessary for GTM Server-side usage
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
